import { render, staticRenderFns } from "./ImpersonationSessions.vue?vue&type=template&id=b581cdee&scoped=true&lang=pug&"
import script from "./ImpersonationSessions.vue?vue&type=script&lang=js&"
export * from "./ImpersonationSessions.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonationSessions.vue?vue&type=style&index=0&id=b581cdee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b581cdee",
  null
  
)

/* custom blocks */
import block0 from "./ImpersonationSessions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports